import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/store";

// CHILD PAGES
const Home = () => import(/* webpackChunkName: "Home" */ "./components/Home");
const Callback = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/b12/B12.vue");
const Register = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/register/register.vue");
const Newyear = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/landingPages/Newyear.vue");
// const Login = () => import(/* webpackChunkName: "Home" */ './components/main/login/login.vue');
// Start new version 2
const Login = () => import("./components/main/login/signIn.vue");
const examLogin = () => import("./components/main/login/examLogin.vue");
const Recoverpassword = () =>
  import("./components/main/password/recoverPassword.vue");
const EmailSent = () => import("./components/main/password/emailSent.vue");
const NewPassword = () => import("./components/main/password/newPassword.vue");
const NewPhonePassword = () =>
  import("./components/main/password/NewPhonePassword.vue");
const RecoveryCompleted = () =>
  import("./components/main/password/recoveryCompleted.vue");
const CodeSent = () => import("./components/main/password/codeSent.vue");
// End new version 2

const parentRegistration = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/register/parentRegistration.vue");
const childRegistration = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/register/childRegistration.vue");
const createRegistration = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/register/createRegistration.vue");
const EmailConfirme = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/register/EmailConfirme.vue");
const phoneConfirme = () =>
  import(/* webpackChunkName: "Home" */ "./components/main/register/phoneConfirm.vue");

// const Connect = () => import(/* webpackChunkName: "Connect" */ './components/main/connect/Connect.vue');
const competition = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/competition/competition.vue");
const thankyou = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/competition/thankyou.vue");
// const Studentoverview = () => import(/* webpackChunkName: "Studentoverview" */'./components/student/studentOverview/studentOverview.vue');
//undelete for old student profile
// const studentProfile = () => import(/* webpackChunkName: "Studentoverview" */'./components/student/studentProfile/studentProfile.vue');
const studentProfile = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/studentProfile/studentProfile.vue");
// const studentProfile = () => import(/* webpackChunkName: "Studentoverview" */'./components/student/studentProfile/studentProfile.vue');
const allNotificationsDisplay = () =>
  import(/* webpackChunkName: "allNotificationsDisplay" */ "./components/student/notifications/allNotificationsDisplay.vue");
// const studentNotifications = () => import(/* webpackChunkName: "studentNotifications" */'./components/student/notifications/studentNotifications.vue');
const assessmentResult = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/assessmentResult/assessmentResult.vue");
const unityGames = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/unityGames/unityGames.vue");
const Lessonprevideo = () =>
  import(/* webpackChunkName: "Lessonprevideo" */ "./components/student/lessonPrevideo/Lessonprevideo.vue");
const Questions = () =>
  import(/* webpackChunkName: "questions" */ "./components/student/questions/questions.vue");
const PageNotFound = () =>
  import(/* webpackChunkName: "PageNotFound" */ "./components/main/pageNotFound/pageNotFound.vue");
const IdeHome = () =>
  import(/* webpackChunkName: "ideHome" */ "./components/student/ide/ideHome.vue");
const Playground = () =>
  import(/* webpackChunkName: "Playground-ide" */ "./components/student/playground/Playground.vue");
const PyhtonIde = () =>
  import(/* webpackChunkName: "Pyhton-ide" */ "./components/student/playground/PyhtonIde.vue");

const web = () =>
  import(/* webpackChunkName: "Playground-ide" */ "./components/student/playground/web.vue");
const Verification = () =>
  import(/* webpackChunkName: "verification" */ "./components/main/password/verification.vue");
// const NewPassword = () => import(/* webpackChunkName: "new" */'./components/main/password/new.vue');
// const StoryVideo = () => import(/* webpackChunkName: "video" */'./components/student/storyVideo/video.vue');
const Privacy = () =>
  import(/* webpackChunkName: "privacy" */ "./components/main/termsAndPrivacy/privacy.vue");
const Terms = () =>
  import(/* webpackChunkName: "terms" */ "./components/main/termsAndPrivacy/terms.vue");
// const Pricing = () => import(/* webpackChunkName: "pricing" */'./components/main/pricing/pricing.vue');
const startLearning = () =>
  import(/* webpackChunkName: "startLearning" */ "./components/main/landingPages/startLearning.vue");
const landingGrants = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/landingPages/landingGrants.vue");
const courses = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/curriculum/courses.vue");
const schoolBusiness = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/forBusiness/schoolBusiness.vue");
const landingKsa = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/landingPages/landingKsa.vue");
const ksaSchools = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/landingPages/ksaSchools.vue");
const school = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/register/types/school/school");
const examRegistration = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/landingPages/examRegistration.vue");
const community = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/Community/mainCommunity.vue");
const communityProfile = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/Community/communityProfile.vue");
const friendsCommunity = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/Community/friendsCommunity.vue");
const friendsView = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/Community/friendsCommunity/friendsView.vue");
const communityHeader = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/shared/communityHeader.vue");

const communityComments = () =>
  import(/* webpackChunkName: "Studentoverview" */ "./components/student/Community/communityComments.vue");
const Perks = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/landingPages/Perks.vue");
const Pricing = () =>
  import(/* webpackChunkName: "Whyhellocode" */ "./components/main/landingPages/Pricing.vue");
// Courses List in student workflow [hellocode-v2]
const myWorld = () =>
  import("./components/student/studentOverview/myWorld.vue");
// lessons List for course [hellocode-v2]
const lessonsList = () =>
  import("./components/student/courseDetails/lessonsList.vue");
// Smoothy Ide [hellocode-v2]
//const smoothyIde = () => import('./components/student/playground/smoothyIde.vue');

// for classera users login

// const draganddrop =() => import('./components/main/games/gamesShared/Newgames/draganddrop.vue')

const classera = () =>
  import(/* webpackChunkName: "classera" */ "./components/main/classera.vue");
const listOfExams = () =>
  import("./components/student/studentExamination/listOfExams.vue");

const puzzleGame = () =>
  import("./components/main/games/gamesShared/Newgames/sliderGame.vue");

Vue.use(VueRouter);

const routes = [
  //--------START CHILD ROUTES----------
  {
    path: "/",
    component: Home,
    name: "Home",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/HappyNewYear",
    component: Newyear,
    name: "Newyear",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/b12/callback",
    component: Callback,
    name: "Callback",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },

  // this for landing page
  // { path: '/register/:type?/:subscription?/:price?/:parentData?', component: Register, name: 'Register', beforeEnter: isLoggedIn, meta: { layout: "student" } },
  //
  {
    path: "/register/school",
    component: school,
    name: "school",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/register",
    component: Register,
    name: "Register",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/register/parent",
    component: parentRegistration,
    name: "parentRegistration",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/register/child",
    component: childRegistration,
    name: "childRegistration",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/register/create/:token",
    component: createRegistration,
    name: "createRegistration",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/register/parent/:email",
    component: EmailConfirme,
    name: "EmailConfirme",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/register/parent/phone/:phone",
    component: phoneConfirme,
    name: "phoneConfirme",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  // { path: '/contact', component: Connect, name: 'Connect', beforeEnter: isLoggedIn, meta: { layout: "student" } },
  {
    path: "/login",
    component: Login,
    name: "Login",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/examLogin",
    component: examLogin,
    name: "examLogin",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },

  // Start new version 2
  {
    path: "/password-recover",
    component: Recoverpassword,
    name: "Recoverpassword",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/email-sent",
    component: EmailSent,
    name: "EmailSent",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  // { path: '/create-new-password', component: CreateNewPassword, name: 'CreateNewPassword', beforeEnter: isLoggedIn, meta: { layout: "student" } },
  {
    path: "/new-password/:isNewPassword",
    component: NewPassword,
    name: "NewPassword",
    beforeEnter: isGest,
    meta: { layout: "student" },
  },
  {
    path: "/recovery-completed",
    component: RecoveryCompleted,
    name: "RecoveryCompleted",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/code-sent/:phone",
    component: CodeSent,
    name: "CodeSent",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/new-phone-password/:phone/:otp",
    component: NewPhonePassword,
    name: "NewPhonePassword",
    beforeEnter: isGest,
    meta: { layout: "student" },
  },

  // End new version 2
  //undelete for old student profile
  {
    path: "/studentprofile",
    component: studentProfile,
    name: "Studentprofile",
    beforeEnter: check,
    meta: { layout: "student" },
  },

  {
    path: "/unitygames",
    component: unityGames,
    name: "Unitygames",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/notifications",
    component: allNotificationsDisplay,
    name: "allNotificationsDisplay",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/assessmentresult/:lessonId",
    component: assessmentResult,
    name: "assessmentResult",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/startLearning",
    component: startLearning,
    name: "startLearning",
    meta: { layout: "student" },
  },
  //--------CODE SHARED ON SOCIALMEDIA-------
  {
    path: "/guest/sharedCode/:submissionId/:submissionType",
    name: "codeShare",
    beforeEnter: isLoggedIn,
    meta: { layout: "guest" },
  },
  {
    path: "/games",
    name: "gamesShared",
    meta: { layout: "guest" },
    beforeEnter: isLoggedIn,

    children: [
      //gamesShared component is rendered when /games/:id is matched
      { path: ":id", meta: { layout: "guest" }, props: true },
    ],
  },
  //Routes for competition
  // { path: '/international-competition-2020-registration', component: competition, name: 'competition', beforeEnter: isLoggedIn, meta: { layout: "student" } },
  // { path: '/thankyou', component: thankyou, name: 'thankyou', beforeEnter: isLoggedIn, meta: { layout: "student" } },
  //

  //--------END CODE SHARED-------
  {
    path: "/international-competition-2020-grants",
    component: landingGrants,
    name: "landingGrants",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/start-early",
    component: landingKsa,
    name: "landingKsa",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/start-early/:email/:name/:school/:phone",
    component: ksaSchools,
    name: "ksaSchools",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/courses",
    component: courses,
    name: "courses",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/lessonprevideo/:courseId/:lessonId/:isLock",
    component: Lessonprevideo,
    name: "Lessonprevideo",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/schoolBusiness",
    component: schoolBusiness,
    name: "schoolBusiness",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  {
    path: "/Certification",
    component: examRegistration,
    name: "examRegistration",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  // COMMUNITY ROUTES
  {
    path: "/community",
    component: community,
    name: "community",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/community/myProfile",
    component: communityProfile,
    name: "communityProfile",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/comments/:postId",
    component: communityComments,
    name: "communityComments",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/community/myFriends",
    component: friendsCommunity,
    name: "myFriends",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/community/profile/:myFriendProfileId",
    component: friendsView,
    name: "friendsView",
    beforeEnter: check,
    meta: { layout: "student" },
  },

  // END COMMUNTY
  {
    path: "/Perks",
    component: Perks,
    name: "Perks",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },
  // { path: '/games/level/:lessonId' ,name: 'Draganddrop',beforeEnter: check, meta: { layout: "game" } },
  {
    path: "/games/level/:lessonId",
    name: "Draganddrop",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/DragandDrop/level/:levelId/:lessonId",
    name: "level",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/Pricing",
    component: Pricing,
    name: "Pricing",
    beforeEnter: isLoggedIn,
    meta: { layout: "student" },
  },

  {
    path: "/maze/:lessonId",
    name: "maze",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/address/:lessonId",
    name: "address",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/address2/:lessonId",
    name: "address2",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/keyboard/:lessonId",
    name: "keyboard",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/keyboard2/:lessonId",
    name: "keyboard2",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/sudoku1/:lessonId",
    name: "sudoku",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/sudoku2/:lessonId",
    name: "sudoku2",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/sudoku3/:lessonId",
    name: "sudoku3",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/coloring3/:lessonId",
    name: "coloring3",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/coloring2/:lessonId",
    name: "coloring2",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/coloring/:lessonId",
    name: "coloring",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/presentation/:lessonId",
    name: "presentation",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/MicrosoftWordProject/:lessonId",
    name: "MicrosoftWordProject",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/PaintChallenge1/:lessonId",
    name: "PaintChallenge1",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/PaintChallenge2/:lessonId",
    name: "PaintChallenge2",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/PaintChallenge3/:lessonId",
    name: "PaintChallenge3",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/PaintChallenge4/:lessonId",
    name: "PaintChallenge4",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/ExcelProject/:lessonId",
    name: "ExcelProject",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/memoryGame/:lessonId",
    name: "memoryGame",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/memoryGame/stage/:stageId/:lessonId",
    name: "memoryGameStages",
    beforeEnter: check,
    meta: { layout: "game" },
  },
  {
    path: "/ide-questions/:id/:coursedId?",
    component: Questions,
    name: "Questions",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/ide/:lessonId/:coursedId?",
    component: IdeHome,
    name: "Ide",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path:
      "/playground-ide/:coursedId?/:lessonId?/:isCourseProject?/:isGraduationProject?/:projectId?/",
    props: true,
    component: Playground,
    name: "playground-ide",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path:
      "/python-ide/:coursedId?/:lessonId?/:isCourseProject?/:isGraduationProject?/:projectId?/",
    props: true,
    component: PyhtonIde,
    name: "python-ide",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path:
      "/web-ide/:coursedId?/:lessonId?/:isCourseProject?/:isGraduationProject?/:projectId?/",
    props: true,
    component: web,
    name: "web-ide",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/verification/:token/:email/:type",
    component: Verification,
    name: "verification",
    meta: { layout: "student" },
  },
  // { path: '/new-password/:isNewPassword/:recoveryUsername', component: NewPassword, name: 'new-password',beforeEnter: isGest, meta: { layout: "student" } },
  // { path: '/story', component: StoryVideo,beforeEnter: check, name: 'story', meta: { layout: "student" } },
  {
    path: "/privacy",
    component: Privacy,
    name: "privacy",
    meta: { layout: "student" },
  },
  {
    path: "/terms/:lang?",
    component: Terms,
    name: "terms",
    meta: { layout: "student" },
  },
  // { path: '/DiscountOffers/:lang?', component: Pricing, name: 'pricing', meta: { layout: "student" } },
  {
    path: "*",
    name: "PageNotFound",
    component: PageNotFound,
    meta: { layout: "student" },
  },
  //--------END CHILD ROUTES----------
  //--------START PARENT ROUTES-------
  {
    path: "/parent/profile",
    name: "profile",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },
  {
    path: "/parent/manageMyKids",
    name: "manageMyKids",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },
  // { path: "/offer/hellocode",name:'offerHellocode', meta: { layout: "parent" },beforeEnter: isParent },
  {
    path: "/parent/thankyou",
    name: "thankyou",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },
  {
    path: "/parent/myorders",
    name: "myorders",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },

  {
    path: "/parent/memberShip",
    name: "memberShip",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },
  {
    path: "/parent/renewSubscription",
    name: "renewSubscription",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },
  //--------END PARENT ROUTES-------
  //--------START TEACHER ROUTES-------
  {
    path: "/teacher/classrooms",
    name: "classrooms",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/code-assessment",
    name: "code-assessment",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/classroomList",
    name: "classroomList",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  // { path: "/teacher/classrooms-details",name:'classrooms-details', meta: { layout: "teacher" }, beforeEnter:isTeacher},
  {
    path: "/teacher/classrooms-details/:id",
    name: "classrooms-details",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/progress-assessment",
    name: "progress-assessment",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/studentQuestions/:studentId/:lessonId",
    name: "studentQuestions",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/submissions/:submissionId/:submissionType",
    name: "submissions",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/teacher-ide",
    name: "teacher-ide",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/web-ide",
    name: "web-teacher-ide",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/python-ide",
    name: "python-teacher-ide",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/question/:lessonId",
    name: "question",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },

  {
    path: "/teacher/classrooms-details/:id/student-profile/:studentId",
    name: "student-profile",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  {
    path: "/teacher/account-info",
    name: "teacherAccountInfo",
    meta: { layout: "teacher" },
    beforeEnter: isTeacher,
  },
  //--------END TEACHER ROUTES-------

  //--------START SCHOOL ROUTES-------
  {
    path: "/school",
    name: "teachers",
    name: "teachers",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school",
    path: "/students",
    name: "students",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school",
    path: "/student-details/:id",
    name: "studentDetails",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school",
    path: "/class-details/:id/:teacherId",
    name: "classDetails",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school",
    path: "/all-student-details/:teacherId/:courseId",
    name: "allStudentDetails",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school/teachers/more/:id",
    name: "teacherMoreDetails",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school/account-info",
    name: "schoolInfo",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/school",
    path: "/reports",
    name: "reports",
    meta: { layout: "school" },
    beforeEnter: isSchoolAdmin,
  },
  {
    path: "/admin",
    name: "admin",
    name: "admin",
    meta: { layout: "admin" },
    beforeEnter: isAdmin,
  },

  //--------END SCHOOL ROUTES-------
  //--------END SCHOOL ROUTES-------

  // Parent Account Info
  {
    path: "/parent/account-info",
    name: "parentAccountInfo",
    meta: { layout: "parent" },
    beforeEnter: isParent,
  },
  // student My World
  {
    path: "/Myworld",
    component: myWorld,
    name: "Myworld",
    beforeEnter: check,
    meta: { layout: "student" },
    props: true,
  },
  {
    path: "/lessonsList/:id",
    component: lessonsList,
    name: "lessonsList",
    beforeEnter: check,
    meta: { layout: "student" },
  },
  {
    path: "/registerExam",
    component: listOfExams,
    name: "registerExam",
    beforeEnter: check,
    meta: { layout: "student" },
  },

  // smoothy ide [hellocode-v2] smoothyIde
  //{ path: '/smoothy-ide/:coursedId?/:lessonId?/:isCourseProject?/:isGraduationProject?/:projectId?/', props: true, component: smoothyIde, name: 'smoothy-ide', beforeEnter: check, meta: { layout: "student" } }

  {
    path: "/:token",
    component: classera,
    name: "classera",
    meta: { layout: "student" },
  },

  {
    path: "/puzzleGame/:lessonId",
    name: "puzzleGame",
    beforeEnter: check,
    meta: { layout: "game" },
  },
];

function check(to, from, next) {
  if (store.state.token) {
    if (to.name == "Lessonprevideo" || to.name == "story") {
      document.querySelector("body").classList.add("lessonbyId");
    } else {
      document.querySelector("body").classList.remove("lessonbyId");
    }
    if (store.state.userType == "student") {
      if (
        store.state.isSchoolStudent == 0 &&
        to.path.includes("/notifications")
      ) {
        next("/"); // Redirect to home page or any other route if the user is not authorized to access community routes
      }
      if (to.path.includes("/community")) {
        next("/"); // Redirect to home page or any other route if the user is not authorized to access community routes
      } else {
        document.querySelector("html").classList.add("hide-footer");
        document.querySelector("html").classList.remove("show-footer");
        next();
      }
    } else {
      next("/parent");
    }
  } else {
    next("/login");
  }
}

function isParent(to, from, next) {
  if (store.state.token && store.state.userType == "parent") {
    next();
  } else {
    next("/login");
  }
}

function isSchoolAdmin(to, from, next) {
  if (store.state.token && store.state.userType == "schooladmin") {
    next();
  } else {
    next("/login");
  }
}
function isAdmin(to, from, next) {
  if (
    store.state.token &&
    store.state.userType == "schooladmin" &&
    store.state.multiple_schools == true
  ) {
    next();
  } else {
    next("/login");
  }
}
function isTeacher(to, from, next) {
  if (store.state.token && store.state.userType == "teacher") {
    next();
  } else {
    next("/login");
  }
}

function isGest(to, from, next) {
  if (store.state.token) {
    store.dispatch("logout", false);
  }
  next();
}

function isLoggedIn(to, from, next) {
  document.querySelector("html").classList.remove("hide-footer");
  document.querySelector("html").classList.add("show-footer");
  if (to.name == "Login" && store.state.token) {
    // I WILL FIX IT ASP
    next("/");
    return;
  } else if (to.name == "Register" && store.state.token) {
    // I WILL FIX IT ASP
    next("/");
    return;
  } else if (to.name == "parentRegistration" && store.state.token) {
    // I WILL FIX IT ASP
    next("/");
    return;
  } else if (to.name == "childRegistration" && store.state.token) {
    // I WILL FIX IT ASP
    next("/");
    return;
  } else if (
    (to.name == "Recoverpassword" ||
      to.name == "NewPassword" ||
      to.name == "EmailSent" ||
      to.name == "RecoveryCompleted" ||
      to.name == "CodeSent" ||
      to.name == "NewPhonePassword" ||
      to.name == "EmailConfirme" ||
      to.name == "phoneConfirme" ||
      to.name == "createRegistration" ||
      to.name == "parentRegistration" ||
      to.name == "examLogin") &&
    store.state.token
  ) {
    next("/");
    return;
  }
  next();
}

export default new VueRouter({ mode: "history", routes });



// WEBPACK FOOTER //
// ./src/routes.js